import { render, staticRenderFns } from "./ListAllSurveys.vue?vue&type=template&id=61606745&scoped=true&"
import script from "./ListAllSurveys.vue?vue&type=script&lang=js&"
export * from "./ListAllSurveys.vue?vue&type=script&lang=js&"
import style0 from "./ListAllSurveys.vue?vue&type=style&index=0&id=61606745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61606745",
  null
  
)

export default component.exports